module.exports = __webpack_public_path__ + "img/pexels-ben-mack-5326990.3465d297.png";